import React from 'react'
import { OrganizationIndustries } from '../../../../application'
import { IndustryCategory } from '../../../../domain/NAICS'
import { industryCategoryToIndustryCategoryTitle } from '../../../../domain/NAICS/industryCategory'
import { IndustryIcon } from '../../../IndustryIcon/IndustryIcon'
import { FilterMenu } from '../components/FilterMenu'
import { FilterMenuItem } from '../components/FilterMenuItem'

interface IndustriesFilterMenuProps {
  industries: OrganizationIndustries
  callback: (industry: keyof OrganizationIndustries) => void
  organizationIndustriesToggle: boolean
  handleOrganizationIndustriesToggle: () => void
}

export const IndustriesFilterMenu: React.FC<IndustriesFilterMenuProps> = ({
  callback,
  industries,
  organizationIndustriesToggle,
  handleOrganizationIndustriesToggle,
}) => {
  const industriesList: Array<keyof OrganizationIndustries> = [
    IndustryCategory.AGRICULTURE_AND_FOOD,
    IndustryCategory.ENERGY_AND_UTILITIES,
    IndustryCategory.FINANCE,
    IndustryCategory.HEALTHCARE,
    IndustryCategory.INDUSTRIAL,
    IndustryCategory.LIFESTYLE,
    IndustryCategory.REAL_ESTATE,
    IndustryCategory.RETAIL,
    IndustryCategory.TECH,
    IndustryCategory.TRANSPORT_AND_VEHICLES,
    IndustryCategory.SPECIALIST_SERVICES,
    IndustryCategory.UNKNOWN,
  ]
  const entry = (code: keyof OrganizationIndustries): React.ReactNode => {
    return (
      <FilterMenuItem
        active={industries[code]}
        toggleActive={() => callback(code)}
        icon={<IndustryIcon industryCategory={code} imageStyle={ICON_STYLE} />}
        key={code}
      >
        {industryCategoryToIndustryCategoryTitle(code)}
      </FilterMenuItem>
    )
  }
  return (
    <FilterMenu
      active={organizationIndustriesToggle}
      toggleActive={handleOrganizationIndustriesToggle}
      title="Company industry"
    >
      {industriesList.map(entry)}
    </FilterMenu>
  )
}

const ICON_STYLE: React.CSSProperties = {
  marginLeft: '1rem',
  width: '2rem',
  height: '2rem',
  objectFit: 'contain',
}
